import { isValidCpf } from '@brazilian-utils/validators';
import { isValid as isValidCnpj } from '@fnando/cnpj';
import { ufOptions } from './data';
import { normalizarDocumento } from './documento';

const getOnlyText = text => text.replace(/[-+.^:,]/g, '');

const isAbbreviation = text => /^([A-Z]\.)+$/.test(text);

const isRomanNumeral = text =>
  /^M{0,4}(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})$/.test(text);

export const capitalize = text => {
  const prepos = ['da', 'do', 'das', 'dos', 'a', 'e', 'de'];
  return text
    .split(' ')
    .map(word => {
      if (ufOptions.some(uf => uf.value === getOnlyText(word))) {
        return word;
      }

      if (isAbbreviation(word) || isRomanNumeral(word)) {
        return word;
      }

      const lowerCaseWord = word.toLowerCase();
      if (prepos.includes(lowerCaseWord)) {
        return lowerCaseWord;
      }

      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
};

// CNPJ alfanumérico permite letras nos 12 primeiros caracteres, então não dá
// mais para decidir CPF x CNPJ contando dígitos puros (`\D`): normalizamos
// removendo qualquer caractere não alfanumérico (`normalizarDocumento`, em
// ./documento) e decidimos pelo tamanho da string limpa (11 = CPF, sempre
// numérico; 14 = CNPJ, pode conter letras nos 12 primeiros caracteres).
export const documentValidator = value => {
  if (!value) return true;
  const clean = normalizarDocumento(value);
  if (clean.length === 11) return isValidCpf(clean);
  if (clean.length === 14) return isValidCnpj(clean);
  return false;
};

export const fileServer = (nome, container = 'documents') =>
  `${process.env.VUE_APP_BLOB_BASE_PATH}/${container}/${nome}`;
